import { FieldValidationError } from '../../../types/form/field-validation-error';
import { getEmailSuggestion } from '../../get-email-suggestion';
export const getEmailSuggestionValidationRule = (formConfig) => {
    return data => {
        const suggestion = getEmailSuggestion(data, formConfig.suggestedEmailDomains);
        if (suggestion) {
            return { error: FieldValidationError.EmailSuggestion, value: suggestion };
        }
    };
};
//# sourceMappingURL=email-suggestion-validation-rule.js.map